import { Fragment } from "react";
import { FilterChip } from "../../filter-chip-group";
import type { OpenFilterArgs } from "../filters";
import type { LocalMaterialFilter, MaterialFilterType } from "../types";
import { extractObservationConditionFilterData } from "./extract-condition-filter-data";

export const ObservationConditionChipGroup = ({
  id,
  filter,
  hidden,
  ...props
}: {
  id: string;
  handleOpenFilter: (args: OpenFilterArgs<MaterialFilterType>) => void;
  handleDelete: (id: string) => void;
  filter: LocalMaterialFilter["lastObservation"];
  hidden?: boolean;
}) => {
  const isFilters = filter?.condition?.or
    ?.flatMap(({ eq }) => eq)
    .filter((val) => val != null);
  const isNotFilters = filter?.condition?.or
    ?.flatMap(({ neq }) => neq)
    .filter((val) => val != null);

  return filter == null || hidden === true ? (
    <Fragment />
  ) : (
    <>
      {isFilters != null && isFilters.length > 0 && (
        <FilterChip
          filterId={id}
          filterType="condition"
          filterData={extractObservationConditionFilterData(filter, "is")}
          operation="is"
          filterLabel="Condition"
          {...props}
        />
      )}
      {isNotFilters != null && isNotFilters.length > 0 && (
        <FilterChip
          filterId={id}
          filterType="condition"
          filterData={extractObservationConditionFilterData(filter, "isNot")}
          operation="is not"
          filterLabel="Condition"
          {...props}
        />
      )}
      {filter.outdated?.eq === true && (
        <FilterChip
          filterId={id}
          filterType="condition"
          operation="is outdated"
          filterLabel="Observation"
          {...props}
        />
      )}
      {filter.null?.eq === true && (
        <FilterChip
          filterId={id}
          filterType="condition"
          operation="has no observation"
          filterLabel="Material"
          {...props}
        />
      )}
    </>
  );
};
